import { updateEvaluatorStatus } from '@/services/evaluator/status';
import { EvaluatorUpdate } from '@/services/evaluator/types';

export async function toggleEvaluatorStatus(
  evaluatorId: string,
  userId: string,
  field: keyof EvaluatorUpdate['field'],
  currentValue: boolean
): Promise<void> {
  await updateEvaluatorStatus(evaluatorId, userId, {
    field,
    value: !currentValue
  });
}